import { useState } from 'react';
import './App.css';
import Hero_score from './components/Hero_score';
import About from './components/About';
import Team from './components/Team';
import Subunits from './components/Subunits';
import Navbar from './layouts/NavBar';
import Events from './components/events/Events';
import NotFound from './layouts/NotFound';
import ReloaderPage from './layouts/Reloader';
import GalleryCarousel from './components/GalleryCarousel';
import CircuitDivider from './components/CircuitDivider';
import AboutTeamDivider from './components/AboutTeamDivider';
import QuoteDivider from './components/QuoteDivider';
import AboutUsPage from './components/AboutUsPage';
import TeamPage from './components/TeamPage';
import SubunitsPage from './components/SubunitsPage';
import ContactPage from './components/ContactPage';
import Footer from './layouts/Footer';

import Awards from './components/Awards';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop';

import { Toaster } from 'react-hot-toast';
import JoinPage from './components/JoinPage';
import ThankYouPage from './components/ThankYouPage';
import AdminDashboard from './components/AdminDashboard';
import UnitRegisterPage from './components/UnitRegisterPage';
import UnitAdminDashboard from './components/UnitAdminDashboard';

// Advanced Animation Components
import SmoothScroll from './components/animations/SmoothScroll';
import CustomCursor from './components/animations/CustomCursor';
import PageTransition from './components/animations/PageTransition';

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Home page with Hero + About + Team + Subunits */}
        <Route 
          path="/" 
          element={
            <PageTransition>
              <Hero_score />
              <About />
              <AboutTeamDivider />
              <Team />
              <CircuitDivider />
              <Subunits />
              <QuoteDivider />
              <GalleryCarousel />
              <div className="-mt-24 relative z-20">
                <Contact />
              </div>
            </PageTransition>
          } 
        />

        {/* Other pages */}
        <Route path="/about" element={<PageTransition><AboutUsPage /></PageTransition>} />
        <Route path="/team" element={<PageTransition><TeamPage /></PageTransition>} />
        <Route path="/subunits" element={<PageTransition><SubunitsPage /></PageTransition>} />
        <Route path="/contact" element={<PageTransition><ContactPage /></PageTransition>} />
        <Route path="/events" element={<PageTransition><Events /></PageTransition>} />
        <Route path="/join" element={<PageTransition><JoinPage /></PageTransition>} />
        <Route path="/thank-you" element={<PageTransition><ThankYouPage /></PageTransition>} />
        <Route path="/admin" element={<PageTransition><AdminDashboard /></PageTransition>} />
        <Route path="/awards" element={<PageTransition><Awards /></PageTransition>} />
        
        {/* Subunit Register Pages */}
        <Route path="/csregister" element={<PageTransition><UnitRegisterPage unit="cs" /></PageTransition>} />
        <Route path="/iasregister" element={<PageTransition><UnitRegisterPage unit="ias" /></PageTransition>} />
        <Route path="/ies-pesregister" element={<PageTransition><UnitRegisterPage unit="ies-pes" /></PageTransition>} />
        <Route path="/wieregister" element={<PageTransition><UnitRegisterPage unit="wie" /></PageTransition>} />
        <Route path="/sightregister" element={<PageTransition><UnitRegisterPage unit="sight" /></PageTransition>} />
        <Route path="/smcregister" element={<PageTransition><UnitRegisterPage unit="smc" /></PageTransition>} />
        <Route path="/rasregister" element={<PageTransition><UnitRegisterPage unit="ras" /></PageTransition>} />

        {/* Subunit Admin Pages */}
        <Route path="/csadmin" element={<PageTransition><UnitAdminDashboard unit="cs" /></PageTransition>} />
        <Route path="/iasadmin" element={<PageTransition><UnitAdminDashboard unit="ias" /></PageTransition>} />
        <Route path="/ies-pesadmin" element={<PageTransition><UnitAdminDashboard unit="ies-pes" /></PageTransition>} />
        <Route path="/wieadmin" element={<PageTransition><UnitAdminDashboard unit="wie" /></PageTransition>} />
        <Route path="/sightadmin" element={<PageTransition><UnitAdminDashboard unit="sight" /></PageTransition>} />
        <Route path="/smcadmin" element={<PageTransition><UnitAdminDashboard unit="smc" /></PageTransition>} />
        <Route path="/rasadmin" element={<PageTransition><UnitAdminDashboard unit="ras" /></PageTransition>} />

        <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [showLoader, setShowLoader] = useState(true);

  return (
    <SmoothScroll>
      <CustomCursor />
      {showLoader && <ReloaderPage onComplete={() => setShowLoader(false)} />}
      <div className={`transition-opacity duration-300 ${showLoader ? 'opacity-0' : 'opacity-100'}`}>
        <Router>
          <ScrollToTop />
          <Toaster position="top-center" />
          <Navbar />
          <AnimatedRoutes />
          <Footer />
        </Router>
      </div>
    </SmoothScroll>
  );
}

export default App;
